import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { trans } from '../../../../_providers/Translation';

function Index(props) {

    const [tabs, setTabs] = useState({
        ripple: true
    })

    return (
        <div className="small-tabs">
            <Tabs
                value={props.tab}
                onChange={(e, id) => props.handleTab(id)}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="primary"
                textColor="primary"
                aria-label="scrollable force tabs"
            >
                <Tab value="active" label={trans('tabs.active')} disableRipple={tabs.ripple} />
                <Tab value="deleted" label={trans('tabs.deleted')} disableRipple={tabs.ripple} />
            </Tabs>
        </div>
    )
}

export default Index;